export const CONTRACT_STATUS: any = {
  signature_contract: 'Firmando',
  deposit_and_first_due: 'Primer pago y deposito',
  monthly_payment: 'Pago mensual',
  recurrent_payment: 'Pago recurrente',
  finish_contract: 'Finalizado',
  disable_contract: 'Contrato desestimado',
};
